<template>
    <div
        class="form-control-validate"
        :class="[message != null ? 'alert-' + message!.type : '', fill ? 'flex-fill' : '']"
    >
        <slot></slot>
        <div
            v-if="!hide && message != null"
            class="alert"
            :class="['alert-' + message.type]"
            v-html="$ti(message!.message, { field: '' }, true)"
        ></div>
    </div>
</template>
<script setup lang="ts">
import { $ti } from '@/locize';
import { type IAlertMessage } from '@/objects/IAlertMessage';

const props = withDefaults(
    defineProps<{
        /**
         * The message to show
         */
        message: IAlertMessage | null;

        /**
         * If the message should be hidden
         * @default false
         */
        hide?: boolean;

        /**
         * If the message should fill the entire line
         * This should usualy be true, but for some componentes i.e DateTimeInput it should be false since we want to control the width of the component
         * @default true
         */
        fill?: boolean;
    }>(),
    {
        hide: false,
        message: null,
        fill: true,
    },
);
</script>
